import _ from 'lodash'
import { MutationTree } from 'vuex'

import { Site } from '@/store/editor-site/types'
import { EntityLevel } from '../types'
import { active, activeNone, current } from '../editor/constants'
import {
  Category,
  ManufacturingSeries,
  Product,
  ProductClass,
  Topology,
} from '../editor/types'
import { IOrderCustomer } from '../orders/types'
import State from './types'

export const mutations: MutationTree<State> = {
  setPreloaded(state, { value }) {
    state.preloaded = value
  },
  setActiveItem(
    state,
    {
      item,
      entityLevel,
    }: {
      item: Category | ProductClass | ManufacturingSeries | Product | Site
      entityLevel: EntityLevel
    },
  ) {
    state.activeItem = _.assign(
      {},
      activeNone,
      active,
      { entityLevel, Created: false },
      _.pick(item, [
        'CategoryId',
        'ProductClassId',
        'ManufacturingSeriesId',
        'ProductId',
        'SiteId',
        'isNone',
      ]),
    )
  },
  setCategoryOpen: (
    state,
    { category, value }: { category: Category; value: boolean },
  ) => {
    category.open = value
    state.categoryOpen[category.CategoryId] = value
  },
  setProductClassOpen: (
    state,
    { productClass, value }: { productClass: ProductClass; value: boolean },
  ) => {
    productClass.open = value
    state.productClassOpen[productClass.ProductClassId] = value
  },
  setManufacturingSeriesOpen: (
    state,
    {
      manufacturingSeries,
      value,
    }: { manufacturingSeries: ManufacturingSeries; value: boolean },
  ) => {
    manufacturingSeries.open = value
    state.manufacturingSeriesOpen[manufacturingSeries.ManufacturingSeriesId] =
      value
  },
  toggleHideNotVisible: (state) => {
    state.hideNotVisible = !state.hideNotVisible
  },
  toggleShowNameInTree: (state) => {
    state.showNameInTree = !state.showNameInTree
  },
  setCollapseState(state, { name, value }) {
    state.collapseOpen[name] = value
  },
  setActiveTopology: (
    state,
    { category, productClass, manufacturingSeries, product }: Topology,
  ) => {
    // TODO: make more shallow?
    state.activeTopology = {
      category: _.assign({}, current, category),
      productClass: _.assign({}, current, productClass),
      manufacturingSeries: _.assign({}, current, manufacturingSeries),
      product: _.assign({}, current, product),
    }
  },
  customersLoaded(state: State, customers: IOrderCustomer[]) {
    state.error = false
    state.customers = customers
  },
  customersError(state) {
    state.error = true
    state.customers = []
  },
  customerShipToLoaded(state: State, customers: IOrderCustomer[]) {
    state.error = false
    state.customerShipTos = customers
  },
  customerShipTosError(state) {
    state.error = true
    state.customerShipTos = []
  },
  customerShipTosCleared(state) {
    state.error = false
    state.customerShipTos = []
  },
  treeTopologyLoaded(state: State, { categories }: { categories: Category[] }) {
    state.error = false
    state.treeCategories = categories
  },
  treeTopologyError(state) {
    state.error = true
    state.treeCategories = []
  },
  setTreeLoading(state, { value }: { value: boolean }) {
    state.treeLoading = value
  },
  categoriesOpenReset(state) {
    state.categoryOpen = {}
    state.productClassOpen = {}
    state.manufacturingSeriesOpen = {}
    state.productOpen = {}
    const collapsedTree = state.treeCategories.map((category) => {
      return {
        ...category,
        open: false,
        ProductClasses: category.ProductClasses.map((product) => {
          return {
            ...product,
            open: false,
            ManufacturingSeries: product.ManufacturingSeries.map((seri) => {
              return { ...seri, open: false }
            }),
          }
        }),
      }
    })

    state.treeCategories = collapsedTree
    state.isShowingProductModels = false
  },
  productSectionsLoadingSet(state, isLoading) {
    state.isProductSectionsLoading = isLoading
  },
}
